import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { ISChipSetComponent } from './is-chipset.component';


@NgModule({
    declarations: [ISChipSetComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule
    ],
    exports: [ISChipSetComponent],
    providers: [],
})
export class ISChipSetModule {}